import moment from 'moment'
import type { PbFindProcessesRequest } from '@itsrever/rever-api'
import type { ProcessesApiFindLineItemsRequest } from '@itsrever/dashboard-api'

export const ALL_ORDERS = 'ALL_ORDERS'
export const ALL_ITEMS = 'ALL_ITEMS'

export interface ListRequestContext {
  ecommerceId?: string
  freetext?: string
}

// Filters only: the tabs add paging and their own return status on top.
export function processesRequestFrom(
  searchParams: URLSearchParams,
  { ecommerceId, freetext }: ListRequestContext
): PbFindProcessesRequest {
  const { gte, lte } = dayRangeFrom(searchParams)
  return {
    ecommerce_id: ecommerceId,
    freetext,
    created_at_gte: gte,
    created_at_lte: lte,
    return_status: returnStatusFrom(searchParams, ALL_ORDERS),
    refund_status: listFrom(
      searchParams,
      'refund_status'
    ) as PbFindProcessesRequest['refund_status'],
    logistics_status: listFrom(
      searchParams,
      'logistics_status'
    ) as PbFindProcessesRequest['logistics_status'],
    compensation: listFrom(searchParams, 'compensation'),
    return_method: joinedFrom(searchParams, 'return_method'),
    country: listFrom(searchParams, 'country'),
    warehouse_id: listFrom(searchParams, 'warehouse_id'),
    carrier: listFrom(searchParams, 'carrier')
  }
}

export function lineItemsRequestFrom(
  searchParams: URLSearchParams,
  { ecommerceId, freetext }: ListRequestContext
): ProcessesApiFindLineItemsRequest {
  const { gte, lte } = dayRangeFrom(searchParams)
  return {
    ecommerceId,
    freetext,
    startedAtGte: gte,
    startedAtLte: lte,
    returnStatus: returnStatusFrom(searchParams, ALL_ITEMS),
    lastKnownShippingStatus: joinedFrom(
      searchParams,
      'last_known_shipping_status'
    ),
    lineItemReturnReason: joinedFrom(searchParams, 'line_item_return_reason'),
    lineItemsReviewsStatus: joinedFrom(
      searchParams,
      'line_items.reviews.status'
    )
  }
}

// The API compares the raw bound, so a bare date would cut the last day at midnight.
function dayRangeFrom(searchParams: URLSearchParams) {
  const from = searchParams.get('from')
  const to = searchParams.get('to')
  return {
    gte: from ? moment(from).startOf('day').toISOString() : undefined,
    lte: to ? moment(to).endOf('day').toISOString() : undefined
  }
}

function returnStatusFrom(searchParams: URLSearchParams, allTab: string) {
  const status = searchParams.get('return_status')
  return status && status !== allTab ? status : undefined
}

function listFrom(searchParams: URLSearchParams, key: string) {
  const values = searchParams.getAll(key)
  return values.length ? values : undefined
}

function joinedFrom(searchParams: URLSearchParams, key: string) {
  return searchParams.getAll(key).join(',') || undefined
}
